import { render, staticRenderFns } from "./MainPanel.vue?vue&type=template&id=c60bc94a&scoped=true"
import script from "./MainPanel.vue?vue&type=script&lang=js"
export * from "./MainPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60bc94a",
  null
  
)

export default component.exports